module.exports = __webpack_public_path__ + "static/media/apple_tv_app_dark.01e5a28d.svg";